// src/store/Reducers/customerActivitySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../utils/config';

/**
 * Thunk to fetch activity for a given userId (matching the route /api/user-activity/:userId).
 */
export const getCustomerActivity = createAsyncThunk(
  'customerActivity/getCustomerActivity',
  async (userId, { rejectWithValue }) => {
    try {
      console.log("Calling GET user-activity for userId:", userId);
      const { data } = await axios.get(`${base_url}/api/user-activity/${userId}`);
      console.log("Response from user-activity GET:", data);
      return data.activity; // an array
    } catch (error) {
      console.error("Error fetching user activity:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerActivitySlice = createSlice({
  name: 'customerActivity',
  initialState: {
    customerActivities: [],
    loader: false,
    errorMessage: '',
    successMessage: ''
  },
  reducers: {
    clearMessages: (state) => {
      state.errorMessage = '';
      state.successMessage = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerActivity.pending, (state) => {
        state.loader = true;
        console.log("Loading user activity data...");
      })
      .addCase(getCustomerActivity.fulfilled, (state, action) => {
        state.loader = false;
        state.customerActivities = action.payload; // the array from data.activity
        console.log("User activity loaded. Items:", action.payload.length);
      })
      .addCase(getCustomerActivity.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload?.error || 'Failed to fetch user activity.';
        console.error("Load user activity error:", state.errorMessage);
      });
  }
});

export const { clearMessages } = customerActivitySlice.actions;
export default customerActivitySlice.reducer;
